module.exports = __webpack_public_path__ + "img/img_chongshenka3@2x.bc8e90a3.png";